import React from 'react';
import { usePromiseFetchSite } from '.';
import { Booking } from '../../interfaces';
import Statsbox from '../../components/stats-box';

const DeliveredBookingsCount = (): JSX.Element => {
  const [fetching, response] = usePromiseFetchSite(
    '/bookings?bookingStatus=Active&status=Delivered'
  );

  const {
    bookings,
    size,
    total
  }: { bookings: Booking[]; size: number; total: number } = response ?? {
    bookings: [],
    size: 40,
    total: 0
  };

  return (
    <a href="/bookings?bookingStatus=Active&amp;status=Delivered">
      <Statsbox
        iconColorClass="text-info"
        bgClass="dark"
        fetching={fetching}
        title={total}
        caption="Delivered bookings"
        faIconName="fas fa-check-circle"
      />
    </a>
  );
};

export default DeliveredBookingsCount;
